/**
 * Labstep
 *
 * @module components/ProtocolStep/Action/StartEnd
 * @desc Button to complete protocolStepId
 */

import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ProtocolStep } from 'labstep-web/models/protocol-step.model';
import { generateNewDateString } from 'labstep-web/services/date.service';
import type React from 'react';
import type { IProtocolStepActionStartEndProps } from './types';

export const ProtocolStepActionStartEnd: React.FC<
  IProtocolStepActionStartEndProps
> = ({
  protocolStep,
  protocolSteps,
  actionComponentProps,
  endedAt,
}) => {
  let protocolStepId;
  if (protocolSteps) {
    protocolStepId = protocolSteps.map((step) => step.id);
  } else {
    protocolStepId = protocolStep.id;
  }
  return (
    <EntityUpdateContainer
      entityName={ProtocolStep.entityName}
      id={protocolStepId}
    >
      {({ update, status }) => (
        <ActionComponent
          dataCy="components/ProtocolStep/Action/StartEnd"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            update({
              ended_at:
                endedAt === null ? null : generateNewDateString(),
            });
          }}
          status={status}
          {...actionComponentProps}
        />
      )}
    </EntityUpdateContainer>
  );
};
